import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
export default function Header1({ variant }) {
  const [mobileToggle, setMobileToggle] = useState(false);
  const [isSticky, setIsSticky] = useState();
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      if (currentScrollPos > prevScrollPos) {
        setIsSticky('cs-gescout_sticky'); // Scrolling down
      } else if (currentScrollPos !== 0) {
        setIsSticky('cs-gescout_show cs-gescout_sticky'); // Scrolling up
      } else {
        setIsSticky();
      }
      setPrevScrollPos(currentScrollPos); // Update previous scroll position
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Cleanup the event listener
    };
  }, [prevScrollPos]);

  return (
    <div>
    <header
      className={`cs_site_header header_style_2 cs_style_1 ${
        variant ? variant : ''
      } cs_sticky_header cs_site_header_full_width ${
        mobileToggle ? 'cs_mobile_toggle_active' : ''
      } ${isSticky ? isSticky : ''}`}
    >
      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
            <Link className="cs_site_branding logo" to="/">
                <img src="/assets/images/logo/logo.svg" alt="Logo" />
              </Link>
              </div>
              <div className="cs_main_header_center">
                <div className="cs_nav cs_primary_font fw-medium">
                  <span
                    className={
                      mobileToggle
                        ? 'cs-munu_toggle cs_teggle_active'
                        : 'cs-munu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                  <Nav setMobileToggle={setMobileToggle} />
                </div>
            </div>
            <div className="cs_main_header_right">
              <div className="header-btn d-flex align-items-center">
                
                <a 
                    href="mailto:contato@fhctraffic.com.br" 
                    className="login-link me-3 d-flex align-items-center text-decoration-none text-dark fw-medium"
                    style={{ zIndex: 1000, position: 'relative', cursor: 'pointer' }}
                >
                    <i className="bi bi-envelope me-2"></i>
                    <span>Contato</span>
                </a>

                <div className="header-button">
                    <a 
                        href="https://wa.me/5511999887766?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20FHC%20Traffic!" 
                        target="_blank"
                        rel="noopener noreferrer"
                        className="theme-btn"
                        style={{ cursor: 'pointer' }}
                    >
                        <span>
                            Solicitar Orçamento
                            <i className="bi bi-arrow-right"></i>
                        </span>
                    </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    </div>

  );
}
